import FadeUp from "./FadeUp";
import { CONTACT } from "../data/content";
import { DEST_IMAGES } from "../data/images";

const OFFERS = [
  {
    title: "Bhopal Trip",
    sub: "Lake City Getaway",
    meta: "195 km · 2.5 hrs",
    gradient: "from-brand to-brand-dark",
    img: DEST_IMAGES.bhopal.card,
  },
  {
    title: "Ujjain Darshan",
    sub: "Mahakaleshwar Temple",
    meta: "55 km · 1 hr",
    gradient: "from-accent to-accent-dark",
    img: DEST_IMAGES.ujjain.card,
  },
  {
    title: "Maheshwar Tour",
    sub: "Narmada Ghats & Fort",
    meta: "90 km · 2 hrs",
    gradient: "from-teal-500 to-teal-700",
    img: DEST_IMAGES.maheshwar.card,
  },
  {
    title: "Pachmarhi Adventure",
    sub: "Hill Station Escape",
    meta: "330 km · 6 hrs",
    gradient: "from-emerald-500 to-emerald-700",
    img: DEST_IMAGES.pachmarhi.card,
  },
];

export default function ExclusiveOffers() {
  return (
    <section id="offers" className="bg-white pb-20 pt-40 md:pt-32">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <FadeUp>
          <div className="mb-10 flex flex-wrap items-end justify-between gap-4">
            <div>
              <p className="section-label">← Exclusive Offers →</p>
              <h2 className="heading-xl text-3xl sm:text-4xl">
                Trending Destinations <br className="hidden sm:block" /> Near You
              </h2>
            </div>
            <p className="max-w-sm text-navy/60">
              Handpicked routes across India with instant confirmation
              and transparent fares.
            </p>
          </div>
        </FadeUp>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {OFFERS.map((o, i) => (
            <FadeUp key={o.title} delay={i * 0.1}>
              <div className="group relative h-72 overflow-hidden rounded-card shadow-card transition-all duration-300 hover:-translate-y-1 hover:shadow-cardHover">
                <img
                  src={o.img}
                  alt={o.title}
                  className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div
                  className={`absolute inset-0 bg-gradient-to-t ${o.gradient} opacity-70 mix-blend-multiply`}
                />
                <div className="relative flex h-full flex-col justify-end p-6 text-white">
                  <span className="mb-1 text-xs font-medium uppercase tracking-wide text-white/80">
                    {o.sub}
                  </span>
                  <h3 className="font-heading text-xl font-bold">{o.title}</h3>
                  <span className="mt-1 text-sm text-white/85">{o.meta}</span>
                  <a
                    href={`https://wa.me/${CONTACT.wa}?text=Hi%2C%20I%20want%20to%20book%20the%20${encodeURIComponent(
                      o.title,
                    )}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-4 inline-flex w-fit items-center gap-2 rounded-full bg-white px-5 py-2 text-sm font-semibold text-navy transition-colors hover:bg-accent hover:text-white"
                  >
                    Book Now →
                  </a>
                </div>
              </div>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
}
